import asyncActionTypes from '../actions/types.js';
import {
  ADD_FREQUENT_FLYER_NUMBER,
  DEEP_LINK_ANCILLARY,
  DEEP_LINK_SEATS,
  INITIAL_CONFIRMATION_MODEL,
  REMOVE_ANCILLARY_FROM_TRAVELERS,
  REMOVE_ANCILLARY_PI_FROM_TRAVELERS,
  RELOAD_BAGGAGE_FLAG,
  UPDATE_STATE_FARE_LOCK,
  WAS_ON_HOLD,
} from '../constants/action-types';
import { CMS_URLS } from '../../scripts/constants/cms-urls';
import LANGUAGE_CODES from '../../scripts/constants/language-codes';
import STOREFRONT_CODES from '../../scripts/constants/storefront-codes';

import PNRUIModel from '../../api-wrapper/ui-models/pnr';
import SeatmapCollectionUIModel from '../../api-wrapper/ui-models/seatmap-collection';
import AncillaryOfferCollectionUIModel from '../../api-wrapper/ui-models/ancillary-offer-collection';
import CHUBBPricesUIModel from '../../api-wrapper/ui-models/chubb-prices';
import ManageConfirmationUIModel from '../../api-wrapper/ui-models/manage-confirmation';
import MealsMenuCollectionUIModel from '../../api-wrapper/ui-models/mealsmenu-collection';
import PreselectSeatsTravelersUIModel from '../../api-wrapper/ui-models/preselect-seats-travelers';
import EMDVoucherRs from '../../api-wrapper/ui-models/emd-voucher-rs';
import {
  getCardInUse,
  getUnlimitedVouchers,
  setUpgradeVouchersAvailable,
} from '../../scripts/utilities/upgrade-vouchers.js';

import { sendNewRelicEvent } from '../../scripts/utilities/newrelic/newrelic-micro-sendEvent.js';
import { RESULT_STATE, PROFILE_OTP_STEP } from '../../scripts/utilities/newrelic/newrelic-constants.js';

const initialState = {
  allDestinationInfo: {},
  allPassengers: null,
  ancillaryOfferCollection : [],
  ancillaryOfferCollectionModel : null,
  ancillaryTypesFromAPI: [],
  associatedTravelers: {},
  bannerFfnAssociation:false,
  confirmationModel: false,
  country: 'mx',
  countryCodeRedirect: null,
  endDestinations: false,
  dualBuyRedeemBaggages: false,
  fFAssociationData: {},
  getAnswerAncillaryCollection: false,
  isFareLock: false,
  isRedeemed: false,
  isStorefrontRedirect: null,
  language: 'es',
  languageCodeRedirect: null,
  loadingAncillaryList: false,
  loadingAllDestinationInfo: false,
  loadingChubbPrice: false,
  loadingconfirmationModel: false,
  loadingPnrInfo: false,
  loadingSeatMap: false,
  loadingTraveler: false,
  pnrInfo: new PNRUIModel(),
  seatMapCollection: null,
  stateStoreFront: {},
  storefront: 'es-mx',
  sendingPayment: false,
  updateShoppingCart: false,
  updateTravelerInfo: null,
  mealsMenuCollection: null,
  metrics: false,
  loadingMealsMenu: false,
  updatingMealsSelected: false,
  showModalAncillaryByDeeplink: false,
  ancillaryTypeWithDeepLink: null,
  showModalMealPreselectByDeeplink: false,
  showModalBaggageByDeeplink: false,
  showModalSeatsByDeeplink: false,
  apiError: null,
  apiWarning: null,
  ApiTime:[],
  ApiTimeError: null,
  controlPanel: {},
  controlPanelError: null,
  sendPurchase: false,
  addFFNumber: false,
  addFFNumberMicro: false,
  statusAddFFNumberMicro: '',
  isErrorPNR: false,
  dataPnrToLoad: null,
  wasOnHold: false,
  cartOnHold: null,
  reloadBaggageFlag: false,
  cartBeforePayment: null,
  preselectSeats: null,
  preselectSeatsError: null,
  previewState: undefined,
  isCurrencyRedirect: false,
  currencyRedirect: 'MXN',
  voucherBeforePayment: false,
  isVoucherValid: false,
  isLoadingVoucherBtn: false,
  removeVoucherValue: false,
  paymentData: null,
  paymentAttempts: 0,
  redirectError: null,
  setPriceChubb: new CHUBBPricesUIModel(),
  profileOtpSettings: {},
  profileRecoverPasswordPin: {},
  benefitsCoreByPassengers: [],
  loadingBenefitCore: false,
  profileRecoverAccount: {},
  userBalance: {},
  errorRedeemingVoucher: null,
  isRedeemingUpgradeVoucher: false,
  voucherRedeemed: [],
  upgradeVoucherRedeemedFlag: false,
  unredeemedVouchers:[],
  upgradeVouchers: {
    availableCards: [],
    cardUsed: '',
    retrievingVouchers: true,
    segmentsSelected: [],
    unlimitedVoucher: null,
    vouchersCard: [],
    vouchersToRedeem: {},
  },
};

const manage = (state = initialState, action) => {
  switch (action.type) {
    //  -----------------       Get Manage PNR
    case asyncActionTypes.RETRIEVE_PNR.START:
      return {
        ...state,
        loadingPnrInfo: true,
        dataPnrToLoad: action.payload.params,
        isCurrencyRedirect: false,
        currencyRedirect: 'MXN',
      };
    case asyncActionTypes.RETRIEVE_PNR.SUCCESS:
      let pnrModel = state.pnrInfo;
      let actionSubmitType = 'FREQUENT_FLYER';
      let isCurrencyRedirect = false;
      let currencyRedirect = 'MXN';
      let countryCodeRedirect = null;
      let isStorefrontRedirect = null;
      let languageCodeRedirect = null ;

      if (action.payload && action.payload.ticketNumber) {
        actionSubmitType = action.payload.ticketNumber > 6 ? 'TICKET' : 'PNR';
      }

      if (action.payload && action.payload.pnrInfo) {
        if (action.payload.pnrInfo._isMinimalAdapter) {
          // MVA: usar stub directamente sin PNRUIModel para microservicio mtpsbk
          pnrModel = {
            cart: { travelerCollection: action.payload.pnrInfo.cart?.travelerInfo?._collection || [] },
            pnrCode: action.payload.pnrInfo.pnrCode || action.payload.pnrInfo.pnr,
          };
        } else {
          action.payload.pnrInfo.actionSubmitType = actionSubmitType;
          pnrModel = new PNRUIModel(action.payload.pnrInfo);
        }
      }
      // Lógica para redirect
      if (action.payload && action.payload.warnings) {
        if (action.payload.warnings.actionable === 'REDIRECT') {
          const currencyArray = action.payload.warnings.msg.split('_');
          isCurrencyRedirect = true;
          currencyRedirect = currencyArray[currencyArray.length - 1];
          languageCodeRedirect = action?.payload?.warnings?.extraInfo?.languageCode;
          countryCodeRedirect = action?.payload?.warnings?.extraInfo?.countryCode;
          isStorefrontRedirect = LANGUAGE_CODES[languageCodeRedirect?.toLowerCase()] && STOREFRONT_CODES[countryCodeRedirect?.toLowerCase()] && CMS_URLS.MANAGE_YOUR_BOOKING[languageCodeRedirect?.toLowerCase()];
        }
      }

      return {
        ...state,
        apiError: null,
        countryCodeRedirect,
        currencyRedirect,
        isCurrencyRedirect,
        isStorefrontRedirect,
        languageCodeRedirect,
        loadingPnrInfo: false,
        pnrInfo: pnrModel,
        sendPurchase: false,
      };
    case asyncActionTypes.RETRIEVE_PNR.FAIL:
      return {
        ...state,
        loadingPnrInfo: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
        isErrorPNR: true,
        isCurrencyRedirect: false,
        currencyRedirect: 'MXN',
      };
    case asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.START:
      return {
        ...state,
        loadingAllDestinationInfo: true,
      };
    case asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.SUCCESS:
      const destinations = state.allDestinationInfo;
      state.allDestinationInfo = {};
      destinations[action.payload.airportCode] = action.payload.response;
      return {
        ...state,
        allDestinationInfo: destinations,
        loadingAllDestinationInfo: false,
        apiError: null,
      };
    case asyncActionTypes.RETRIEVE_ALL_DESTINATION_INFO.FAIL:
      return {
        ...state,
        loadingAllDestinationInfo: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };

    case asyncActionTypes.RETRIEVE_NONE_DESTINATION_INFO.SUCCESS:
      const noneDestinations = state.allDestinationInfo;
      state.allDestinationInfo = {};
      noneDestinations[action.payload.airportCode] = action.payload.response;
      return {
        ...state,
        allDestinationInfo: noneDestinations,
        loadingAllDestinationInfo: false,
        endDestinations: true,
        apiError: null,
      };

    //  -----------------       Get All Ancillaries
    case asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.START:
      return {
        ...state,
        loadingAncillaryList: true,
      };
    case asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.SUCCESS:
      // Transform 0CZ from pricesAncillaryWrapper to _collection format
      const ancillaryCollection = [...action?.payload?._collection];
      
      // Add 0CZ if exists in pricesAncillaryWrapper
      if (action?.payload?.pricesAncillaryWrapper?.prices?.['0CZ']) {
        const czData = Object.values(action?.payload?.pricesAncillaryWrapper?.prices?.['0CZ'])[0]?.[0];
        if (czData) {
          ancillaryCollection.push({
            _meta: { class: 'AncillaryOffer' },
            ancillary: {
              _meta: { class: 'Ancillary' },
              type: '0CZ',
              commercialName: czData?.commercialName,
              currency: czData?.currency,
              owningCarrierCode: 'AM',
            },
          });
        }
      }
      
      const ancillaryTypesFromAPI = ancillaryCollection.map(( obj ) => {
        if (obj.ancillary && typeof obj.ancillary !== 'undefined' ) {
          return obj.ancillary;
        }
        return obj;
      });
      return {
        ...state,
        ancillaryOfferCollection: ancillaryCollection, // Now includes 0CZ if available
        ancillaryOfferCollectionModel: new AncillaryOfferCollectionUIModel(action.payload),
        ancillaryTypesFromAPI: [ ...ancillaryTypesFromAPI ], // Solo los tipos de ancillary que me sirven de criterio para poder comparar contra lo del CMS.
        loadingAncillaryList: false,
        loadingconfirmationModel: false,
        getAnswerAncillaryCollection: true,
        sendPurchase: false,
        apiError: null,
      };
    case asyncActionTypes.RETRIVE_ALL_ANCILLARIES_PNR.FAIL:
      return {
        ...state,
        loadingAncillaryList: false,
        getAnswerAncillaryCollection: true,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };

    // Put ShopingCart
    case asyncActionTypes.RETRIEVE_SHOPPING_CART.START:
      return {
        ...state,
        updateShoppingCart: true,
        loadingTraveler: true,
        isRedeemed: false,
        loadingTravelerIndex: action.data.indexPassenger,
      };
    case asyncActionTypes.RETRIEVE_SHOPPING_CART.SUCCESS:
      // Update state with response
      state.pnrInfo.setTravelerCollection(action.payload.response.travelerInfo);
      state.pnrInfo.setCart(action.payload.response);

      return {
        ...state,
        updateShoppingCart: false,
        loadingTraveler: false,
        metrics: true,
        updateTravelerInfo: action.payload.response,
        isRedeemed: action.payload.isRedeemed,
        apiError: null,
        apiWarning: { actionType: action.type, warnings: action.payload.response._warnings._collection },
        loadingTravelerIndex: action.payload.indexPassengerBack,
        allPassengers: action.payload.response.travelerInfo,
      };
    case asyncActionTypes.RETRIEVE_SHOPPING_CART.FAIL:
      return {
        ...state,
        updateShoppingCart: false,
        loadingTraveler: false,
        updateTravelerInfo: null,
        isRedeemed: false,
        apiError: { actionType: action.type, errorData: action.payload.response ? action.payload.response : action.payload },
      };

    // Get chubbPrice
    case asyncActionTypes.RETRIEVE_CHUBBPRICES.START:
      return {
        ...state,
        loadingChubbPrice: true,
      };
    case asyncActionTypes.RETRIEVE_CHUBBPRICES.SUCCESS:
      return {
        ...state,
        setPriceChubb: new CHUBBPricesUIModel(action.setPriceChubb),
        loadingChubbPrice: false,
        apiError: null,
      };
    case asyncActionTypes.RETRIEVE_CHUBBPRICES.FAIL:
      return {
        ...state,
        loadingChubbPrice: false,
        previewState: action.previewState,
      };

    // Get SeatMap
    case asyncActionTypes.RETRIEVE_SEATMAPS.START:
      return {
        ...state,
        loadingSeatMap: true,
      };
    case asyncActionTypes.RETRIEVE_SEATMAPS.SUCCESS:
      return {
        ...state,
        seatMapCollection: new SeatmapCollectionUIModel(action.payload),
        loadingSeatMap: false,
        apiError: null,
      };
    case asyncActionTypes.RETRIEVE_SEATMAPS.FAIL:
      return {
        ...state,
        loadingSeatMap: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };

    // Get Meals Menu
    case asyncActionTypes.RETRIEVE_MEALSMENU.START:
      return {
        ...state,
        loadingMealsMenu: true,
      };
    case asyncActionTypes.RETRIEVE_MEALSMENU.SUCCESS:
      return {
        ...state,
        mealsMenuCollection: new MealsMenuCollectionUIModel(action.payload),
        loadingMealsMenu: false,
        apiError: null,
      };
    case asyncActionTypes.RETRIEVE_MEALSMENU.FAIL:
      return {
        ...state,
        loadingMealsMenu: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };

    // Save Meals Selected
    case asyncActionTypes.SUBMIT_MEALS_SELECTED.START:
      return {
        ...state,
        updatingMealsSelected: true,
      };
    case asyncActionTypes.SUBMIT_MEALS_SELECTED.SUCCESS:
      return {
        ...state,
        updatingMealsSelected: false,
        apiError: null,
      };
    case asyncActionTypes.SUBMIT_MEALS_SELECTED.FAIL:
      return {
        ...state,
        updatingMealsSelected: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };

    // Post Submit Payment
    case asyncActionTypes.SUBMIT_PAYMENT.START:
      return {
        ...state,
        loadingconfirmationModel: true,
        sendingPayment: true,
        cartBeforePayment: action.payload,
        voucherBeforePayment: state.pnrInfo.getVoucher(),
      };
    case asyncActionTypes.SUBMIT_PAYMENT.SUCCESS:
      state.pnrInfo.setTravelerCollection(action.payload.cartConfirmation.travelerInfo);
      state.pnrInfo.setReservationStatus('PAID');
      state.pnrInfo.setCartId(null);
      return {
        ...state,
        action,
        // confirmationModel: new ManageConfirmationUIModel(mockupConfirmation),
        confirmationModel: new ManageConfirmationUIModel(action.payload),
        // loadingconfirmationModel: false,
        sendingPayment: false,
        sendPurchase: true,
        apiError: null,
        showModalAncillaryByDeeplink: false,
        showModalMealPreselectByDeeplink: false,
        showModalBaggageByDeeplink: false,
        ancillaryTypeWithDeepLink: null,
      };
    case asyncActionTypes.SUBMIT_PAYMENT.FAIL:
      return {
        ...state,
        confirmationModel: false,
        loadingconfirmationModel: false,
        sendingPayment: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
        paymentData: action.payload.purchaseOrder,
        paymentAttempts: state.paymentAttempts + 1,
      };

    case asyncActionTypes.SET_DESTINATIONS.SUCCESS:
      return {
        ...state,
        endDestinations: action.payload,
      };
    case asyncActionTypes.SET_STORE_FRONT.SUCCESS:
      return {
        ...state,
        storefront: action.payload,
      };
    case asyncActionTypes.SET_LANGUAGE.SUCCESS:
      return {
        ...state,
        language: action.payload,
      };
    case asyncActionTypes.SET_STATE_STORE_FRONT.SUCCESS:
      if ( action.payload ) {
        return {
          ...state,
          country: action.payload.country,
          stateStoreFront: action.payload.dataStoreFronts[action.payload.country][action.payload.language],
        };
      }
      break;
    case asyncActionTypes.SET_EMD_VOUCHER.START:
      return {
        ...state,
        isLoadingVoucherBtn: true,
      };
    case asyncActionTypes.SET_EMD_VOUCHER:
      pnrModel = state.pnrInfo;
      pnrModel.cart.emdVoucherRs = new EMDVoucherRs(action.payload.response);
      return {
        ...state,
        pnrInfo: pnrModel,
        isVoucherValid: action.payload.response.valid,
        isLoadingVoucherBtn: false,
      };
    case asyncActionTypes.SET_EMD_VOUCHER.FAIL:
      pnrModel = state.pnrInfo;
      pnrModel.cart.emdVoucherRs = null;
      return {
        ...state,
        pnrInfo: pnrModel,
        isLoadingVoucherBtn: false,
        isVoucherValid: false,
        apiError: { actionType: action.type, errorData: action.payload.response },
      };
    case asyncActionTypes.REMOVE_EMD_VOUCHER.START:
      return {
        ...state,
        removeVoucherValue: false,
        isLoadingVoucherBtn: true,
      };
    case asyncActionTypes.REMOVE_EMD_VOUCHER:
      pnrModel = state.pnrInfo;
      pnrModel.cart.emdVoucherRs = null;
      return {
        ...state,
        pnrInfo: pnrModel,
        isVoucherValid: false,
        isLoadingVoucherBtn: false,
        removeVoucherValue: true,
      };
    case asyncActionTypes.REMOVE_EMD_VOUCHER.FAIL:
      return {
        ...state,
        isLoadingVoucherBtn: false,
        removeVoucherValue: false,
      };
    case asyncActionTypes.SET_VALID_VOUCHER_VARS:
      return {
        ...state,
        isVoucherValid: true,
      };
    case asyncActionTypes.REMOVE_EMD_VOUCHER_WITHOUT_API:
      pnrModel = state.pnrInfo;
      pnrModel.cart.emdVoucherRs = null;
      return {
        ...state,
        pnrInfo: pnrModel,
        isVoucherValid: false,
        isLoadingVoucherBtn: false,
        removeVoucherValue: true,
      };
    case asyncActionTypes.REMOVE_EMD_VOUCHER_VALUE:
      pnrModel = state.pnrInfo;
      pnrModel.cart.emdVoucherRs = null;
      return {
        ...state,
        pnrInfo: pnrModel,
        removeVoucherValue: false,
        isVoucherValid: false,
      };
    case REMOVE_ANCILLARY_FROM_TRAVELERS:
      const travelersToRemove = action.payload.travelers;
      const ancillaryType = action.payload.ancillaryType;
      pnrModel = state.pnrInfo;
      pnrModel.cart.travelerCollection.forEach( traveler => {
        const isTravelersToRemove = travelersToRemove.filter( travelerToRemove => travelerToRemove.traveler.id === traveler.id && travelerToRemove.isToRemove );
        if (isTravelersToRemove !== undefined) {
          isTravelersToRemove.forEach(isTravelerToRemove => {
            traveler.removeAncillary(ancillaryType, isTravelerToRemove.legCode);
          });
        }
      });

      return {
        ...state,
        pnrInfo: pnrModel,
      };
    case REMOVE_ANCILLARY_PI_FROM_TRAVELERS:
      const travelersToRemovePI = action.payload.travelers;

      pnrModel = state.pnrInfo;
      pnrModel.cart.travelerCollection.forEach( traveler => {
        const isTravelersToRemove = travelersToRemovePI.filter( travelerToRemove => travelerToRemove.traveler.id === traveler.id );
        isTravelersToRemove.forEach(travelerToRemove => {
          travelerToRemove.traveler.listOptionsUpgrade.map(ancillary => {
            traveler.removeAncillary(ancillary.ancillary.type, isTravelersToRemove.legCode);
          });
        });
      });

      return {
        ...state,
        pnrInfo: pnrModel,
      };
    case DEEP_LINK_ANCILLARY:
      let showModalAncillary = true;
      let showModalMeal = false;
      let showModalBaggage = false;
      if (action.payload.ancillaryType === 'MEAL') {
        showModalMeal = true;
        showModalAncillary = false;
        showModalBaggage = false;
      } else if (action.payload.ancillaryType === 'MALETAS') {
        showModalMeal = false;
        showModalAncillary = false;
        showModalBaggage = true;
      }
      return {
        ...state,
        showModalAncillaryByDeeplink: showModalAncillary,
        showModalMealPreselectByDeeplink: showModalMeal,
        showModalBaggageByDeeplink: showModalBaggage,
        ancillaryTypeWithDeepLink: action.payload.ancillaryType,
      };
    case DEEP_LINK_SEATS:
      return {
        ...state,
        showModalSeatsByDeeplink: true,
      };
    case ADD_FREQUENT_FLYER_NUMBER:
      return {
        ...state,
        addFFNumber: action.payload,
      };
    case WAS_ON_HOLD:
      return {
        ...state,
        wasOnHold: action.payload.status,
        cartOnHold: action.payload.cartOnHold,
      };
    case RELOAD_BAGGAGE_FLAG:
      return {
        ...state,
        reloadBaggageFlag: action.payload.status,
      };

    case asyncActionTypes.PUT_TIME_API.START:
      return {
        ...state,
        ApiTime: [],
        ApiTimeError: null,
      };
    case asyncActionTypes.PUT_TIME_API.SUCCESS:
      return {
        ...state,
        ApiTime: action.payload,
        ApiTimeError: null,
      };
    case asyncActionTypes.PUT_TIME_API.FAIL:
      return {
        ...state,
        ApiTime: [],
        ApiTimeError: action.payload,
      };

    case asyncActionTypes.CONTROL_PANEL.START:
      return {
        ...state,
        controlPanel: {},
        controlPanelError: null,
      };

    case asyncActionTypes.CONTROL_PANEL.SUCCESS:
      return {
        ...state,
        controlPanel: action.payload,
        controlPanelError: null,
      };
    case asyncActionTypes.CONTROL_PANEL.FAIL:
      return {
        ...state,
        controlPanel: {},
        controlPanelError: action.payload,
      };
    case asyncActionTypes.SEAT_PRESELECT.START:
      return {
        ...state,
        preselectSeats: null,
        loadingSeatMap: true,
        preselectSeatsError: null,
      };

    case asyncActionTypes.SEAT_PRESELECT.SUCCESS:
      return {
        ...state,
        preselectSeats: new PreselectSeatsTravelersUIModel(action.payload),
        loadingSeatMap: false,
        preselectSeatsError: null,
      };
    case asyncActionTypes.SEAT_PRESELECT.FAIL:
      return {
        ...state,
        preselectSeats: null,
        loadingSeatMap: false,
        preselectSeatsError: action.payload,
      };
    case asyncActionTypes.FFN_ASSOCIATION.START:
      return {
        ...state,
        bannerFfnAssociation: false,
        fFAssociationData: {},
      };

    case asyncActionTypes.FFN_ASSOCIATION.SUCCESS:
      return {
        ...state,
        bannerFfnAssociation: true,
        fFAssociationData: action.payload,
      };
    case asyncActionTypes.FFN_ASSOCIATION.FAIL:
      return {
        ...state,
        bannerFfnAssociation: false,
        fFAssociationData: {},
      };
    case asyncActionTypes.DUAL_BUY_REDEEMED_BAGGAGES:
      return {
        ...state,
        dualBuyRedeemBaggages: action.payload.status,
      };
    case INITIAL_CONFIRMATION_MODEL:
      return {
        ...state,
        confirmationModel: false,
      };
    case asyncActionTypes.SET_ERROR_REDIRECT:
      return {
        ...state,
        redirectError: true,
      };
    case asyncActionTypes.UPDATE_SEATMAP_COLLECTION:
      const {
        seat: {
          seatMapCollection,
          seats,
        },
      } = action;

      const {
        _seatmapsBySegment,
      } = seatMapCollection;

      if (_seatmapsBySegment && _seatmapsBySegment.length !== 0) {
        _seatmapsBySegment.forEach(seatmap => {
          const {
            segment: {
              segmentCode,
            },
          } = seatmap;

          if (segmentCode === action.seat.segmentCode) {
            seatmap.sections.forEach(section => {
              section.rows.forEach(row => {
                row.seats.forEach(seat => {
                  if (seats.includes(seat.code)) {
                    seat.status = 'UNAVAILABLE';
                  }
                });
              });
            });
          }
        });
      }

      return {
        ...state,
        seatMapCollection,
      };
    case asyncActionTypes.RESET_SEATMAP_COLLECTION:
      return {
        ...state,
        seatMapCollection: null,
      };
    case UPDATE_STATE_FARE_LOCK:
      return {
        ...state,
        isFareLock: action.payload.stateFareLock,
      };
    // OTP Settings
    case asyncActionTypes.RECOVER_OTP_SETTINGS.START:
      return {
        ...state,
        profileOtpSettings: {
          recoverOtpSettingsLoading: true,
          recoverOtpSettingsError: null,
          recoverOtpSettingsSent: null,
        },
      };
    case asyncActionTypes.RECOVER_OTP_SETTINGS.SUCCESS:
      sendNewRelicEvent({
        actionType: 'RECOVER_OTP_SETTINGS',
        resultState: RESULT_STATE.SUCCESS,
        step: PROFILE_OTP_STEP.OTP,
        state,
      });

      return {
        ...state,
        apiError: null,
        profileOtpSettings: {
          recoverOtpSettingsLoading: false,
          recoverOtpSettingsError: null,
          recoverOtpSettingsSent: action.payload,
        },
      };
    case asyncActionTypes.RECOVER_OTP_SETTINGS.FAIL:
    {
      const {
        reset = false,
        type,
        payload,
      } = action;

      const apiError = !reset ? { actionType: type, errorData: payload } : state.apiError;

      if (payload) {
        sendNewRelicEvent({
          actionType: 'RECOVER_OTP_SETTINGS',
          resultState: RESULT_STATE.FAILURE,
          errorCode: action?.payload?.code,
          step: PROFILE_OTP_STEP.OTP,
          state,
        });
      }

      return {
        ...state,
        apiError,
        profileOtpSettings: {
          recoverOtpSettingsLoading: false,
          recoverOtpSettingsError: payload,
          recoverOtpSettingsSent: null,
        },
      };
    }
    // Recover password/PIN storing response from micro-service
    case asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.START:
      return {
        ...state,
        profileRecoverPasswordPin: {
          recoverPasswordLoading: true,
          recoverPasswordPinError: null,
          recoverPasswordPinSent: null,
        },
      };
    case asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.SUCCESS:
      const payload = action?.payload?.response;
      const request = action?.payload?.rest;

      sendNewRelicEvent({
        actionType: 'RECOVER_OTP_SETTINGS',
        resultState: RESULT_STATE.SUCCESS,
        step: request?.newNip ? PROFILE_OTP_STEP.NIP : PROFILE_OTP_STEP.PASSWORD,
        state,
      });

      return {
        ...state,
        apiError: null,
        profileRecoverPasswordPin: {
          recoverPasswordLoading: false,
          recoverPasswordPinError: null,
          recoverPasswordPinSent: payload,
        },
      };
    case asyncActionTypes.SET_ACCOUNT_PASSWORD_PIN.FAIL:
    {
      const {
        reset = false,
        type,
        payload,
      } = action;

      const {
        error = null,
        request = null,
      } = payload || {};

      const apiError = !reset ? { actionType: type, errorData: error } : state.apiError;

      if (error) {
        sendNewRelicEvent({
          actionType: 'RECOVER_OTP_SETTINGS',
          resultState: RESULT_STATE.FAILURE,
          errorCode: error?.code,
          step: request?.newNip ? PROFILE_OTP_STEP.NIP : PROFILE_OTP_STEP.PASSWORD,
          storefront: state.storefront,
          state,
        });
      }

      return {
        ...state,
        apiError,
        profileRecoverPasswordPin: {
          recoverPasswordLoading: false,
          recoverPasswordPinError: error,
          recoverPasswordPinSent: null,
        },
      };
    }
    case asyncActionTypes.FFN_ASSOCIATION_MICRO.START:
      return {
        ...state,
        addFFNumberMicro: false,
        apiError: null,
        loadingTraveler: true,
        statusAddFFNumberMicro: 'START',
      };
    case asyncActionTypes.FFN_ASSOCIATION_MICRO.SUCCESS:
      sendNewRelicEvent({
        actionType: 'FFN_ASSOCIATION_MICRO',
        associationMethod: action?.associationMethod,
        request: action?.request,
        response: action,
        resultState: RESULT_STATE.SUCCESS,
        state,
      });

      return {
        ...state,
        addFFNumberMicro: true,
        apiError: null,
        associatedTravelers: {
          ...state.associatedTravelers,
          ...action.payload,
        },
        loadingTraveler: false,
        statusAddFFNumberMicro: 'SUCCESS',
      };
    case asyncActionTypes.FFN_ASSOCIATION_MICRO.FAIL:
      sendNewRelicEvent({
        actionType: 'FFN_ASSOCIATION_MICRO',
        associationMethod: action?.associationMethod,
        errorCode: action?.payload?.code,
        request: action?.request,
        resultState: RESULT_STATE.FAILURE,
        state,
      });

      return {
        ...state,
        addFFNumberMicro: false,
        apiError: { actionType: action.type, errorData: action.payload },
        loadingTraveler: false,
        statusAddFFNumberMicro: 'FAIL',
      };
    case asyncActionTypes.RETRIEVE_BENEFITS_CORE.START:
      return {
        ...state,
        loadingBenefitCore: true,
        apiError: null,
      };
    case asyncActionTypes.RETRIEVE_BENEFITS_CORE.SUCCESS:
      sendNewRelicEvent({
        actionType: 'RETRIEVE_BENEFITS_CORE',
        resultState: RESULT_STATE.SUCCESS,
        response: action,
        state,
      });

      return {
        ...state,
        apiError: null,
        benefitsCoreByPassengers: action.payload,
        loadingBenefitCore: false,
      };
    case asyncActionTypes.RETRIEVE_BENEFITS_CORE.FAIL:
      sendNewRelicEvent({
        actionType: 'RETRIEVE_BENEFITS_CORE',
        errorCode: action?.payload?.code,
        resultState: RESULT_STATE.FAILURE,
        state,
      });

      return {
        ...state,
        loadingBenefitCore: false,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    // Recover Account
    case asyncActionTypes.RECOVER_ACCOUNT.START:
      return {
        ...state,
        profileRecoverAccount: {
          recoverAccountLoading: true,
          recoverAccountError: null,
          recoverAccountSent: null,
        },
      };
    case asyncActionTypes.RECOVER_ACCOUNT.SUCCESS:
      sendNewRelicEvent({
        actionType: 'RECOVER_ACCOUNT',
        resultState: RESULT_STATE.SUCCESS,
        state,
      });

      return {
        ...state,
        apiError: null,
        profileRecoverAccount: {
          recoverAccountLoading: false,
          recoverAccountError: null,
          recoverAccountSent: action.payload,
        },
      };
    case asyncActionTypes.RECOVER_ACCOUNT.FAIL:
    {
      const {
        payload,
        reset = false,
        type,
      } = action;

      const apiError = !reset ? { actionType: type, errorData: payload } : state?.apiError;

      if (payload?.code) {
        sendNewRelicEvent({
          actionType: 'RECOVER_ACCOUNT',
          resultState: RESULT_STATE.FAILURE,
          errorCode: payload?.code,
          state,
        });
      }

      return {
        ...state,
        apiError,
        profileRecoverAccount: {
          recoverAccountLoading: false,
          recoverAccountError: payload,
          recoverAccountSent: null,
        },
      };
    }
    case asyncActionTypes.GET_BALANCE_MICRO.START:
      return {
        ...state,
      };
    case asyncActionTypes.GET_BALANCE_MICRO.SUCCESS:
      if (window.newrelic) {
        sendNewRelicEvent({
          actionType: 'GET_BALANCE_MICRO',
          response: action?.payload,
          resultState: RESULT_STATE.SUCCESS,
          state,
          subflow: action?.subflow,
          tierAMR: action?.payload?.code_tier,
        });
      }

      return {
        ...state,
        userBalance: action.payload,
      };
    case asyncActionTypes.GET_BALANCE_MICRO.FAIL:
      if (window.newrelic) {
        sendNewRelicEvent({
          actionType: 'GET_BALANCE_MICRO',
          errorCode: action?.payload?.code,
          resultState: RESULT_STATE.FAILURE,
          result: {
            request: action.incident.apiUrl,
          },
          state,
          subflow: action?.subflow,
        });
      }

      return {
        ...state,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.START:
      return {
        ...state,
        apiError: null,
        errorRedeemingVoucher: null,
        upgradeVouchers: {
          availableCards: [],
          cardUsed: '',
          retrievingVouchers: true,
          segmentsSelected: [],
          vouchersCard: {},
          vouchersToRedeem: [],
        },
      };
    case asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.SUCCESS:
    {
      const {
        payload,
      } = action;
      const { upgrades } = payload;

      sendNewRelicEvent({
        actionType: 'UPGRADE_VOUCHER',
        resultState: RESULT_STATE.SUCCESS,
        step: 'GET',
        state,
      });

      return {
        ...state,
        apiError: null,
        errorRedeemingVoucher: null,
        upgradeVouchers: {
          ...state.upgradeVouchers,
          availableCards: [],
          retrievingVouchers: false,
          segmentsSelected: [],
          unlimitedVoucher: getUnlimitedVouchers(upgrades),
          vouchersCard: upgrades || [],
          vouchersToRedeem: upgrades ? setUpgradeVouchersAvailable(upgrades) : {},
        },
      };
    }
    case asyncActionTypes.RETRIEVE_UPGRADE_VOUCHER.FAIL:
    {
      const {
        payload,
        type,
      } = action;

      sendNewRelicEvent({
        actionType: 'UPGRADE_VOUCHER',
        resultState: RESULT_STATE.FAILURE,
        errorCode: action?.payload?.code,
        step: 'GET',
        state,
      });

      return {
        ...state,
        apiError: { actionType: type, errorData: payload },
        errorRedeemingVoucher: payload?.actionable,
        upgradeVouchers: {
          ...state.upgradeVouchers,
          availableCards: [],
          retrievingVouchers: false,
          segmentsSelected: [],
          vouchersCard: [],
          vouchersToRedeem: {},
        },
      };
    }
    case 'UPGRADE_VOUCHER_REDEEM_VOUCHER':
    {
      const { value } = action;
      const { type } = value;
      const {
        cardUsed,
        segments,
        vouchersToRedeem,
      } = type;

      const {
        upgradeVouchers,
      } = state;

      const {
        unlimitedVoucher,
      } = upgradeVouchers;

      const cardInUsed = getCardInUse(cardUsed, vouchersToRedeem, segments.length, unlimitedVoucher);
      return {
        ...state,
        upgradeVouchers: {
          ...upgradeVouchers,
          cardUsed: cardInUsed,
          segmentsSelected: segments,
          vouchersToRedeem: { ...vouchersToRedeem },
        },
      };
    }
    case 'RETRIEVE_UPGRADE_VOUCHER_RESET':
      return {
        ...state,
        upgradeVouchers: {
          ...state.upgradeVouchers,
          cardUsed: '',
          retrievingVouchers: false,
          unlimitedVoucher: [],
          segmentsSelected: [],
          vouchersCard: action.value,
          vouchersToRedeem: setUpgradeVouchersAvailable(action.value),
        },
      };
    case 'SET_UPGRADE_VOUCHER_CARDS':
      return {
        ...state,
        upgradeVouchers: {
          ...state.upgradeVouchers,
          availableCards: action.value,
        },
      };
    case 'SET_UPGRADE_VOUCHER_REDEEMED':
    {
      const { value } = action;
      return {
        ...state,
        upgradeVoucherRedeemedFlag: value,
      };
    }
    case asyncActionTypes.SET_UPGRADE_VOUCHER.START:
      return {
        ...state,
        errorRedeemingVoucher: null,
        isRedeemingUpgradeVoucher: true,
        unredeemedVouchers: [],
        voucherRedeemed: [],
      };
    case asyncActionTypes.SET_UPGRADE_VOUCHER.SUCCESS:
    {
      const {
        payload,
        request,
        responseFromApi,
      } = action;

      const {
        voucherRedeemed,
        unredeemedVouchers,
      } = payload;

      sendNewRelicEvent({
        actionType: 'UPGRADE_VOUCHER',
        resultState: RESULT_STATE.SUCCESS,
        responseFromApi,
        request,
        step: 'POST',
        state,
        vouchersStatus: payload,
      });

      return {
        ...state,
        apiError: null,
        errorRedeemingVoucher: null,
        isRedeemingUpgradeVoucher: false,
        unredeemedVouchers: unredeemedVouchers,
        voucherRedeemed: voucherRedeemed,
      };
    }
    case asyncActionTypes.SET_UPGRADE_VOUCHER.FAIL:
    {
      const {
        payload,
        request,
        responseFromApi,
        type,
      } = action;

      const {
        unredeemedVouchers = [],
      } = payload;

      sendNewRelicEvent({
        actionType: 'UPGRADE_VOUCHER',
        resultState: RESULT_STATE.FAILURE,
        errorCode: action?.payload?.code,
        responseFromApi,
        request,
        step: 'POST',
        state,
        vouchersStatus: unredeemedVouchers?.length ? { unredeemedVouchers } : {},
      });

      return {
        ...state,
        apiError: { actionType: type, errorData: payload },
        errorRedeemingVoucher: payload?.actionable,
        isRedeemingUpgradeVoucher: false,
        segmentsSelected: [],
        unlimitedVoucher: [],
        unredeemedVouchers: [],
        voucherRedeemed: [],
      };
    }

    default:
      return state;
  }
};

export default manage;